"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface PetNameInputProps {
  petName: string;
  setPetName: (name: string) => void;
  error: string;
  isLoading: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
}

const PetNameInput: React.FC<PetNameInputProps> = ({
  petName,
  setPetName,
  error,
  isLoading,
  inputRef,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="pet-name">{t("petDetails.petName")}</Label>
      <Input
        id="pet-name"
        type="text"
        value={petName}
        onChange={(e) => setPetName(e.target.value)}
        disabled={isLoading}
        className={cn(error && "border-destructive focus-visible:ring-destructive")}
        ref={inputRef}
        maxLength={255}
      />
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};

export default PetNameInput;
